/* eslint-disable no-console */
export type LogMethod = (...args: unknown[]) => void;

const isProd = import.meta.env.PROD === true;

const noOp: LogMethod = () => { };

export const logger = {
    debug: isProd ? noOp : ((...args: unknown[]) => console.debug(...args)),
    info: isProd ? noOp : ((...args: unknown[]) => console.info(...args)),
    warn: ((...args: unknown[]) => console.warn(...args)),
    error: ((...args: unknown[]) => console.error(...args)),
} as const;


